import BaseNameField from 'registration/js/base/fields/name';

import template from 'registration/templates/simple/fields/name.html';

const NameField = BaseNameField.extend({
    template
});

export default NameField;



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/simple/fields/name.js